export default __webpack_public_path__ + "static/docHome-5f77f690d5ea4facc84675470e22fad9.svg";